import classNames from "classnames";

function Emoji2({ selected = false, onClick }) {
  return (
    <svg
      width="57"
      height="55"
      viewBox="0 0 57 55"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="cursor-pointer group"
      onClick={onClick}
    >
      <path
        d="M28.6222 48.0208C40.0116 48.0208 49.2445 38.8336 49.2445 27.5006C49.2445 16.1677 40.0116 6.98047 28.6222 6.98047C17.2329 6.98047 8 16.1677 8 27.5006C8 38.8336 17.2329 48.0208 28.6222 48.0208Z"
        className={classNames(
          "group-hover:fill-[#FFCC80]",
          selected ? "fill-[#FFCC80]" : "fill-[#E2E2E2]"
        )}
      />
      <g filter="url(#filter0_d_16442_1309)">
        <path
          d="M28.6222 48.0208C40.0116 48.0208 49.2445 38.8336 49.2445 27.5006C49.2445 16.1677 40.0116 6.98047 28.6222 6.98047C17.2329 6.98047 8 16.1677 8 27.5006C8 38.8336 17.2329 48.0208 28.6222 48.0208Z"
          stroke="white"
          strokeWidth="5"
          strokeMiterlimit="10"
          shapeRendering="crispEdges"
        />
      </g>
      <path
        d="M23.1439 26.3426C24.0974 26.3426 24.8704 24.9739 24.8704 23.2856C24.8704 21.5972 24.0974 20.2285 23.1439 20.2285C22.1904 20.2285 21.4175 21.5972 21.4175 23.2856C21.4175 24.9739 22.1904 26.3426 23.1439 26.3426Z"
        className={classNames(
          "group-hover:fill-[#1E1E1E]",
          selected ? "fill-[#1E1E1E]" : "fill-[#666666]"
        )}
      />
      <path
        d="M34.1078 26.3426C35.0613 26.3426 35.8342 24.9739 35.8342 23.2856C35.8342 21.5972 35.0613 20.2285 34.1078 20.2285C33.1543 20.2285 32.3813 21.5972 32.3813 23.2856C32.3813 24.9739 33.1543 26.3426 34.1078 26.3426Z"
        className={classNames(
          "group-hover:fill-[#1E1E1E]",
          selected ? "fill-[#1E1E1E]" : "fill-[#666666]"
        )}
      />
      <path
        d="M22.2808 34.9399C23.7285 28.3252 33.5571 28.2982 34.9708 34.9399C31.885 30.0837 25.3734 30.1108 22.2808 34.9399Z"
        className={classNames(
          "group-hover:fill-[#1E1E1E]",
          selected ? "fill-[#1E1E1E]" : "fill-[#666666]"
        )}
      />
      <defs>
        <filter
          id="filter0_d_16442_1309"
          x="1.5"
          y="0.480469"
          width="54.2446"
          height="54.041"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.650151 0 0 0 0 0.650151 0 0 0 0 0.650151 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_16442_1309"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_16442_1309"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
}

export default Emoji2;
